import { reduce, keyBy } from "lodash";

export default (flattenedLineItems) => {
  return reduce(
    flattenedLineItems,
    (obj, li) => {
      return {
        ...obj,
        ...keyBy(li.cells, "id"),
      };
    },
    {}
  );
};
